<template>
  <div class="input-group">
    <div class="input-text input-text--bold">
      Загрузите документы
    </div>

    <div class="file-area">
      <input
        ref="fileInput"
        multiple
        type="file"
        class="file-area__input"
        @change="handleFileChange"
      >
      <div class="file-area__content">
        <div class="file-area__title">
          <svg width="20" height="20">
            <use xlink:href="#icon-upload" />
          </svg>
          Прикрепить файлы
        </div>
        <div class="file-area__text">
          Общий объем файлов не должен превышать 20 Мб
        </div>
      </div>
    </div>

    <ul v-if="files.length" class="file-area-list">
      <li v-for="(origin, id) in files" :key="id">
        <div
          class="file-area-list__close"
          @click="$emit('removeFile', origin.path, id)"
        >
          <svg width="14" height="14">
            <use xlink:href="#icon-close" />
          </svg>
        </div>
        <div v-if="availableImageExtensions.includes(typeOfFiles?.[origin.path])" class="document-image">
          <img
            :src="origin.path"
            :loading="'lazy'"
          >
        </div>
        <div
          v-else
          class="document-image"
        >
          <span>{{ typeOfFiles?.[origin.path] }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    files: {
      type: Array,
      default: () => []
    },

    availableImageExtensions: {
      type: Array,
      default: () => []
    },

    availableVideoExtensions: {
      type: Array,
      default: () => []
    },

    availableFileExtensions: {
      type: Array,
      default: () => []
    },

    typeOfFiles: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    handleFileChange (event) {
      this.$emit('uploadFile', event)
      this.$refs.fileInput.value = '' // Очистка input
    }
  }
}
</script>
